var _g, _g2, _title, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempatIbadah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-6.4 -6.4 76.80 76.80",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6.4,
    y: -6.4,
    width: 76.8,
    height: 76.8,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "pray-night")), /*#__PURE__*/React.createElement("g", {
    id: "pray-night"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,27.006C54,13.1,30,1.818,30,1.818S6,13.1,6,27.006A25.951,25.951,0,0,0,10.047,41H10V63H50V41h-.047A25.951,25.951,0,0,0,54,27.006Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 14,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 25,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 47,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 31,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 33,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 34,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 47,
    r: 1
  })), /*#__PURE__*/React.createElement("line", {
    x1: 30.263,
    y1: 31.681,
    x2: 29,
    y2: 26,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.581,17.4a5.383,5.383,0,0,0,.158,1.155L21.893,23.2a4.093,4.093,0,0,0,1.7,2.435h0L20.273,47.311,20,50.994a5.594,5.594,0,0,0,5.23,5.582L32,57,14,60l-3.029,3H37.515A6.485,6.485,0,0,0,44,56.315a6.666,6.666,0,0,0-6.754-6.286H32.471l.4-4.587a9.37,9.37,0,0,0,0-1.624",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.59,25.911l4.823-1.234-1.838-8.45a4.934,4.934,0,0,0-.359-.986",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,11.094h7.23A2.071,2.071,0,0,1,30.2,13.166v2.929a0,0,0,0,1,0,0H18.833a0,0,0,0,1,0,0V13.166A2.071,2.071,0,0,1,20.9,11.094Z",
    transform: "translate(-2.159 4.975) rotate(-11.102)",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.743,34.835a1.411,1.411,0,0,0-1.738-.448l-4.446,2.076-6.5,3.035-5.707-7.836c-1.039-1.426-2.786-1.923-3.9-1.11h0c-1.116.813-1.179,2.628-.14,4.054l6.09,8.361c1.451,1.992,3.891,2.686,5.45,1.551l6.421-4.677,4.165-3.034A1.413,1.413,0,0,0,48.743,34.835Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.559,
    y1: 36.463,
    x2: 44.268,
    y2: 39.841,
    style: {
      fill: "#e7d1c4",
      stroke: "#000000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 57,
    x2: 35,
    y2: 57,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 19.463,
    x2: 43,
    y2: 20.878,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 25.122,
    x2: 43,
    y2: 26.537,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.463,
    y1: 23,
    x2: 40.878,
    y2: 23,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.122,
    y1: 23,
    x2: 46.537,
    y2: 23,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 63,
    x2: 56,
    y2: 63,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempatIbadah);
export default __webpack_public_path__ + "static/media/tempat_ibadah.92a34b88e878e459f9cbb53ac0ca6250.svg";
export { ForwardRef as ReactComponent };